import React from "react";
import FullStackEnginnerContent from "../function-components/Courses/FullStackEnginnerContent";

function SolutionArchitect({bannerimg}) {
  return (
    <>
      <FullStackEnginnerContent bannerimg={bannerimg} />
    </>
  );
}

export default SolutionArchitect;
